export default {
  props: {
    team: Object,
    rank: Number
  }
}
